<template>
    <div>
        <!--loader - message---> 
        <div v-if="showDiv != '2'"> 
			<div class="d-flex align-items-center justify-content-between">
				<div class="titlepage">
				 <h5 class="my-2">{{$t('apiAccounts')}}</h5>	
				</div>
				<div class="createButton text-right mb-3">
				 	<a class="btn_xs grd_btn newtrading d-inline-flex align-items-center" href="#" @click.prevent="showDiv = '2'"  v-if="totalRestApiAccounts <= 2  && showDiv == '1'"><feather type="edit"> </feather> Create {{$t('TradingAccount')}} </a>
			    </div> 
			    <div class="createButton text-right mb-3" style="right: 220px">
				 <a class="btn_xs grd_btn newtrading d-inline-flex align-items-center" href="/api-documentation"><feather type="book-open"> </feather> {{$t('apiDocumentation')}} </a>
			    </div> 
			</div>
			<div class="whiteBG radius pt-3 col-12 inMiddle-area table-responsive">
				 <table class="table customize">
					<thead>
						<tr>
							<th>{{$t('accountId')}}</th>
							<th>{{$t('currency')}}</th>
							<th>{{$t('platform')}}</th>
							<th>{{$t('demoLive')}}</th>
							<th>{{$t('accountType')}}</th>
							<th>{{$t('leverage')}}</th>
							<th></th> 
						</tr>
					</thead>
					<tbody  v-if="(!pageLoader && restApiAccountsData != '' && totalRestApiAccounts > 0)">
						<tr class="selectHere" v-for="(list,index) in restApiAccountsData.records" v-if="parseInt(list.is_api_account) == 1">
							<td>{{list.account_id}}</td>
							<td><img :src="'../../../../static/fxView/images/'+currency[list.currency.toUpperCase()]" class="data_currency rounded-circle"></td>
							<td>{{list.platform}}</td>
							<td v-html="(parseInt(list.demo_live) == 0)? 'demo' :'live'"></td>
							<td>{{list.account_type}}</td>
							<td>{{list.leverage}}</td>
							<td width="120">
								<div class="d-flex align-items-center"> 
									<router-link :to="{name: 'fxView.deposit' , params: { 'account_id':list.account_id , 'act_account_id' : list.act_account_id}}" class="prism_btn titleBG btn_xs">{{ $t('fxAddFunds') }}</router-link>
									<div class="position-relative ml-3">
										<span class="tableoption dotAreaForButton" @click.prevent="detailDiv(index,'buttons',list.account_id,list.act_account_id)"><feather type="more-horizontal" size="1rem"></feather></span>								
										<div class="tablefilter box-shadow"  :ref="'buttons'+index" v-if="parseInt(showButtonDetailInfo) == index">
											 <ul>
											 	<li>
											 		<router-link :to="{name: 'fxView.changeLeverage' , params: { 'account_id':list.account_id, 'leverage':list.leverage, 'act_account_id' : list.act_account_id , 'demo_live' : list.demo_live, 'platform' : list.platform}}">{{$t('changeLeverage')}}</router-link>
										 		</li>
										 		<li>
										 			<router-link :to="{name: 'fxView.changePassword' , params: { 'account_id':list.account_id, 'act_account_id' : list.act_account_id, 'demo_live' : list.demo_live, 'platform' : list.platform}}">{{$t('changePassword')}}</router-link>
									 			</li>
									 			<li>
									 				<router-link :to="{name: 'fxView.internalTransfer' , params: { 'account_id':list.account_id, 'act_account_id' : list.act_account_id, 'demo_live' : list.demo_live, 'platform' : list.platform , 'from_currency': list.currency}}">{{$t('internalTransfer')}}</router-link>
									 			</li>
											 </ul>
										</div>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
					<loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="restApiAccountsData" v-else></loader-component>
				</table> 
			</div>
		</div>
		<div v-if="showDiv == '2'">
			<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
			<div v-if="congratulation_module"> 
				<div class="middleBox whitebox border radius  mb-3"> 
					<div class="congratulations">
						<div class="logo_congrats">
							<img src="../../../../static/fxView/images/check.svg" alt="Congratulations">
						</div>
						<div class="subtitle">
							<h3> {{$t('congo')}} <span class="green">{{get_user.profile.firstname}} {{get_user.profile.lastname}}</span></h3>
							<p> {{$t('createAccountMsz1')}}</p>
							<ul class="includeWdth">
								<li><strong> {{$t('tradingId')}}</strong> {{account_detail.account_id}} </li>
								<li><strong> {{$t('password')}}</strong>{{firstChar(account_detail.password)}}</li>
								<li><strong> {{$t('leverage')}}</strong> {{account_detail.leverage}}</li>
								<li><strong> {{$t('accountBaseCurrency')}}</strong> {{account_detail.currency}}</li>
							</ul>
						</div>
					</div> 
					<div class="full-width  submitButton align-items-center justify-content-center d-flex mt-3 w-100">
						<a class="bkList" href="#" @click.prevent="showDiv = '1'">{{$t('backlist')}}</a>
						<router-link :to="'/api-documentation'">{{$t('SeeApiDoc')}}</router-link> 
					</div> 
				</div>
				
			</div> 
			<div v-else>  
				<div class="stepForm">
					<div class="mainTitle text-center mt-4 mb-3">
						<h3 class="mb-4"> {{$t('open')}} {{$t('fxACT')}} <span v-html="parseInt(demo_live_select) == 0? 'Demo' : 'Live'"></span> {{$t('tradingAcc')}} </h3>
						<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
					</div> 
					<div class="middleBox inMiddle-area radius whitebox p-4"> 
							<div class="row">
								<div class="col-12 mb-3">
									<div class="slctcurrency">
										<h4 class="mb-3"> {{$t('currency')}}</h4>
										<ul>
											<li :class="(select_currency == 'USD')?'selected':''" @click.prevent="select_currency = 'USD'">
												<img src="../../../../static/fxView/images/usd.svg" alt="usd">
												 {{$t('USD')}}
											</li>
											<li :class="(select_currency == 'EUR')?'selected':''" @click.prevent="select_currency = 'EUR'">
												<img src="../../../../static/fxView/images/eur.svg" alt="eur">
												 {{$t('EUR')}}
											</li>
											<li :class="(select_currency == 'GBP')?'selected':''" @click.prevent="select_currency =  'GBP'">
												<img src="../../../../static/fxView/images/gbp.svg" alt="gbp">
												 {{$t('GBP')}}
											</li>
											<li :class="(select_currency == 'AUD')?'selected':''" @click.prevent="select_currency = 'AUD'">
												<img src="../../../../static/fxView/images/aud.svg" alt="aud">
												 {{$t('AUD')}}
											</li>
										</ul> 
									</div>
								</div>
								<div class="col-12 mb-3">
									<input type="hidden" v-model="leverage" v-validate="'required'" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('leverage') }" ref="leverageInput" name="leverage">
									<div class="slctcurrency" >
										<h4 class="mb-3"> {{$t('leverage')}}</h4>
										<ul v-if="get_user.pro_user == 1">
										   <li  class="disabled" v-html="$t('X30')"> </li>
											<li :class="(leverage == '100')?'selected':''" @click.prevent="leverage = '100'" v-html="$t('pro100')"> </li>
											<li :class="(leverage == '200')?'selected':''" @click.prevent="leverage = '200'" v-html="$t('pro200')"> </li>
											<li :class="(leverage == '300')?'selected':''" @click.prevent="leverage = '300'" v-html="$t('pro300')"> </li>
											<li :class="(leverage == '400')?'selected':''" @click.prevent="leverage = '400'" v-html="$t('pro400')"> </li>
											<li :class="(leverage == '500')?'selected':''" @click.prevent="leverage = '500'" v-html="$t('pro500')"> </li> 
											
										</ul>
										<ul v-else>
											<li :class="(leverage == '30')?'selected':''" @click.prevent="leverage = '30'"  v-html="$t('X30')"> </li>
											<li  class="disabled"  v-html="$t('pro100')"> </li>
											<li class="disabled" v-html="$t('pro200')"> </li>
											<li class="disabled" v-html="$t('pro300')"> </li>
											<li class="disabled" v-html="$t('pro400')"> </li>
											<li class="disabled" v-html="$t('pro500')"> </li>
										</ul>
										<ul v-if="errors.first('leverage')"><li class="error">{{$t('leverageField')}}</li></ul>
									</div>
								</div> 
								<div class="col-12 col-md-12 border-top pt-3">
									<div class="acPassword">
										<h3 class="mb-3"> {{$t('password')}}</h3>
									</div>
									<div class="row mt-3">
										<div class="col-12 col-md-6">
											<div class="form-group field-wrapper">
												<input :type="inputtype" placeholder=" " v-model="password" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{6,24}$/}" name="password" :class="{ 'is-invalid': submitted && errors.has('password') }" ref="passwordInput" >
												<label for="password" class="float-label"> {{$t('accountPassword')}}</label>
												<feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility('1')"></feather>
												<p class="error" v-for="error in errors.collect('password')">
													<span v-show="error == 'The password field is required.'">{{$t('passwordFieldReq')}}</span>
													<span v-show="error == 'The password field format is invalid.'">{{$t('passWordMustContain')}}</span>
												</p>
											</div>
										</div>
										<div class="col-12 col-md-6">
											<div class="form-group field-wrapper">
												<input :type="inputtype1" placeholder=" " v-model="confirmPassword" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{6,24}$/, confirmed:password}" name="confirmPassword" :class="{ 'is-invalid': submitted && errors.has('confirmPassword') }" ref="confirmPasswordInput" >
												<label for="password" class="float-label"> {{$t('conPassword')}}</label>
												<feather :type="iconType1" class="toggle-password" @click.prevent="switchVisibility('2')"></feather> 
												<p class="error" v-for="error in errors.collect('confirmPassword')">
													<span v-show="error == 'The confirmPassword field is required.'">{{$t('passwordFieldReq')}}</span>
													<span v-show="error == 'The confirmPassword field format is invalid.'">{{$t('passWordMustContain')}}</span>
													<span v-show="error == 'The confirmPassword confirmation does not match.'">{{$t('newConfFieldSame')}}</span>
												</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-12 mt-3">
									<div class="full-width submitButton justify-content-center align-items-center  d-flex  mt-3 w-100">
										<a class="bkList mr-3" href="#" @click.prevent="showDiv = '1'">{{$t('backlist')}}</a>
										<button class="prism_btn btn_sm" @click.prevent="submit()"> {{$t('createAccount')}} </button>
									</div>
								</div>
							</div>
						
					</div> 
				</div> 
			</div>
		</div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    export default {
        name: 'CREATE-ACCOUNT',
        mixins: [fxViewMixins],
        data() {
            return {
				showDiv : '1',
				col_span : 7,
				mszValidation : '',
                pageLoader : false,
                response_msg : '',
                msg_type : '',
                select_currency : 'EUR',
                account_type : 'ECN',
                platform : 'ACT',
                leverage : '',
                password : '',
                confirmPassword : '',
                submitted : false,

                congratulation_module : false,
                account_detail : {},

                inputtype:'password',
                showpassword: false,
                iconType : 'eye-off',
                inputtype1:'password',
                showpassword1: false,
                iconType1 : 'eye-off',
                demo_live_select : '1',
				showButtonDetailInfo : '',
				
				totalRestApiAccounts : '',
				restApiAccountsData : []
            }
        },
        methods:{
			listing(){
        		let input_json={
        			'globalParams' : {
        				filter : {'demo_live' : '1'},
                        sort: [],
                        search: '',
                        page: 1,
                        perPage: 15,
        			} ,
        			'localParams' : {'parameter' : this , 'page' :'rest-api'}
        		}
        		this._runGetTradingAccountList(input_json)
        	},
			detailDiv(index,getData,account_id,act_account_id) {
        		//this.account_id = account_id
				//this.act_account_id = act_account_id
				if(getData == 'div'){
					if ($(this.$refs[getData+index]).hasClass('hide')){
						$(this.$refs[getData+index]).removeClass('hide');
					}else{
						$(this.$refs[getData+index]).addClass('hide');
					} 
				}else{
					if(parseInt(this.showButtonDetailInfo) == index){
						this.showButtonDetailInfo = ''
					}else{
						this.showButtonDetailInfo = index
					}
				}
            },
            firstChar(getPassword){
                let first =  getPassword.charAt(0)
                let last = getPassword.charAt(getPassword.length - 1)
                return first+'*****'+last; 
            },
            switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }else{
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }
                
            },
            
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
						let accountJson={
							'globalParams' : {
								'currency' :_that.select_currency,
								'account_type' : _that.account_type,
								'platform' : _that.platform,
								'leverage' : _that.leverage,
								'password' : _that.password,
								'demo_live' : _that.demo_live_select.toString(),
								'is_api_account' : 1
							},
							'localParams' : {'parameter' : _that}
						}
						_that._runCreateApiSubscription(accountJson)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        },
        created(){
			if(this.get_user.pro_user != 1){
				this.leverage = '30'
			}
			this.listing()
        },
		mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.dotAreaForButton').length){
                    _that.showButtonDetailInfo = ''
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/rest_api.vue